const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Task',
        dataIndex: 'taskName',
        render: defaultRender,
    },
    {
        title: 'Assigned To',
        dataIndex: 'employeeName',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Start Date',
        dataIndex: 'startDate',
        render: defaultRender,
    },
    {
        title: 'Completed Date',
        dataIndex: 'completedDate',
        render: defaultRender,
    },
];

export default columns;
